import React from 'react';
import { useDispatch } from 'react-redux';
import { ADDITIONAL_R2R } from '@/constants/additionalR2R';
import RadioButtonController from '@/components/radioButtonController';
import { LABEL_SIZE, LABEL_COLOR } from '@/components/radioButton';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';

function ChooseRentPayment({
  control,
  rentPayments,
  action = null,
  getValues,
  step,
  showForm = true,
  withHorizontalSeparator = false,
}) {
  const dispatch = useDispatch();
  const { TITLE, ID, PAYMENTS } = ADDITIONAL_R2R;
  const { payments, paymentSelected, productName } = { ...rentPayments };

  return (
    <>
      <div className="choose-rent-payments-container">
        <FormTemplate
          titleText={TITLE}
          cyData={ID}
          theme={THEMES.LONG}
          step={step}
          withHorizontalSeparator={withHorizontalSeparator}
        >
          <Text
            text={`Elige la cuota mensual de tu ${productName}`}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.CAPTION2}
            cyData={`${ID}__choose-rent-payments_text`}
          />
          {showForm && (
            <div className="choose-rent-payments__radio-button">
              <RadioButtonController
                inputName={PAYMENTS.NAME}
                inputId={PAYMENTS.ID}
                control={control}
                rules={{
                  required: PAYMENTS.RULES.REQUIRED,
                }}
                label={PAYMENTS.LABEL}
                options={payments}
                withBox={false}
                withCheck
                column
                defaultValue={paymentSelected?.value}
                handleOnChange={() => {
                  if (action) {
                    dispatch(
                      action({
                        formData: getValues(),
                        showAdviseNewShoppingCartModal: false,
                      })
                    );
                  }
                }}
                labelSize={LABEL_SIZE.CAPTION1}
                labelColor={LABEL_COLOR.GREY5}
              />
            </div>
          )}
        </FormTemplate>
      </div>

      <style jsx>
        {`
          .choose-rent-payments-container {
            position: relative;
            display: flex;
            flex-direction: column;
            .choose-rent-payments-container--row {
              max-width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            .choose-rent-payments__radio-button {
              margin-top: 8px;
            }
          }
        `}
      </style>
    </>
  );
}
export default ChooseRentPayment;
